import React from 'react'
import SelectedCheckbox from "./SelectedCheckbox"
import {getLocalData} from "../../../../services/StorageServices";
import {callPhone} from "../../../../services/api/apiPhoneConnect";
import {message} from "antd";

function CustomerManagerTableItem(props) {
    const {item, arrSelected, onSelected} = props

    const _callPhoneOut = async (phoneNumber) => {
        try {
            const ipPhone = getLocalData('ipPhone')
            const user = getLocalData('userLoginPhone')

            const payload = {
                phoneNumber: phoneNumber,
                ext: ipPhone,
                transactionId: item.customerId,
                userName: user,
                outSys: "CRM",
                type: "customer"
            }

            const response = await callPhone(payload)

            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }
        } catch (e) {
            message.error(e.message)
        }
    }

    const _renderPhone = (phone) => {
        const arrPhone = phone.split(",")
        return arrPhone.map((item, index) => {
            return <div key={index} className="cursor-pointer LinkPhone" onClick={() => _callPhoneOut(item)}>
                {item}
            </div>
        })
    }

    return (
        <tr className="RowItem">
            <td className="selectItem">
                <SelectedCheckbox
                    id={item.customerId}
                    arrSelected={arrSelected}
                    onSelected={onSelected}
                />
            </td>
            <td className="itemCol">{item.name}</td>
            <td className="itemCol">{_renderPhone(item.phone)}</td>
            <td className="status">{item.customerTypeId === 1 ? "Đã gọi" : "Chưa gọi"}</td>
        </tr>
    )
}

export default CustomerManagerTableItem
